import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import LogoBlanco from '../../assets/logoBlanco.png';
import { Button } from '../ui/Button';
import { siteConfig } from '../../config/site';
import { scrollToMap } from '../sections/AmbHeroSection';
import { trackEvent, FunnelSteps } from '../../lib/analytics';
import { cn } from '../../lib/cn';

export function AmbHeader() {
  const [open, setOpen] = useState(false);

  const appUrl = siteConfig.urls.app;

  const handleMapCta = (e) => {
    e.preventDefault();
    trackEvent(FunnelSteps.CTA_CLICKED, { location: 'header' });
    scrollToMap();
    setOpen(false);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-[200] glass">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <a href={siteConfig.urls.marketing}>
          <img src={LogoBlanco} alt="SpecifiC" className="h-9 w-auto" />
        </a>

        <nav className="hidden items-center gap-6 lg:flex">
          <a href={`#${siteConfig.anchors.howItWorks}`} className="text-sm font-medium text-white/80 hover:text-white">
            Cómo funciona
          </a>
          <a href={`#${siteConfig.anchors.value}`} className="text-sm font-medium text-white/80 hover:text-white">
            Beneficios
          </a>
          <a href={`#${siteConfig.anchors.trust}`} className="text-sm font-medium text-white/80 hover:text-white">
            Experiencias
          </a>
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Button href={appUrl} variant="ghost" size="sm" className="text-white hover:bg-white/10" data-cta="login">Iniciar sesión</Button>
          <Button size="sm" onClick={handleMapCta} data-cta="header-generate">Generar análisis</Button>
        </div>

        <button type="button" className="rounded-lg p-2 text-white lg:hidden" onClick={() => setOpen(!open)} aria-label="Menú">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <div className={cn('glass border-t border-white/10 lg:hidden', open ? 'block' : 'hidden')}>
        <nav className="flex flex-col gap-1 px-4 py-4 text-white">
          <a href={`#${siteConfig.anchors.howItWorks}`} className="rounded-lg px-3 py-2 text-sm hover:bg-white/10" onClick={() => setOpen(false)}>
            Cómo funciona
          </a>
          <a href={`#${siteConfig.anchors.value}`} className="rounded-lg px-3 py-2 text-sm hover:bg-white/10" onClick={() => setOpen(false)}>
            Beneficios
          </a>
          <a href={`#${siteConfig.anchors.trust}`} className="rounded-lg px-3 py-2 text-sm hover:bg-white/10" onClick={() => setOpen(false)}>
            Experiencias
          </a>
          <Button href={appUrl} variant="outline" size="sm" className="mt-2 w-full">Iniciar sesión</Button>
          <Button size="sm" className="w-full" onClick={handleMapCta}>Generar análisis</Button>
        </nav>
      </div>
    </header>
  );
}
